import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { TextAction } from '@leagueplatform/genesis-core';
import { useChallengesAnalytics } from '#hooks/use-challenges-analytics.hook.tsx';
import {
  TLP_DETAIL,
  TLP_SCREEN_NAMES,
} from '#constants/analytics.constants.tsx';
import { TeamInviteLinkModal } from './team-invite-link-modal/team-invite-link-modal.component';

type TeamInviteAnchorProps = {
  teamId: string;
  teamName: string;
};

export function TeamInviteAnchor({ teamId, teamName }: TeamInviteAnchorProps) {
  const { formatMessage } = useIntl();
  const [displayTeamInviteLinkModal, setDisplayTeamInviteLinkModal] =
    React.useState(false);
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();

  const handleAnalyticsClick = () =>
    trackChallengesAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      screen_name: TLP_SCREEN_NAMES.TEAM_DETAILS,
      detail: TLP_DETAIL.INVITE,
      team_name: teamName,
      team_id: teamId,
    });

  return (
    <>
      <TextAction
        onClick={() => {
          setDisplayTeamInviteLinkModal(true);
          handleAnalyticsClick();
        }}
      >
        {formatMessage({ id: 'INVITE' })}
      </TextAction>
      <TeamInviteLinkModal
        isOpen={displayTeamInviteLinkModal}
        onDismiss={() => setDisplayTeamInviteLinkModal(false)}
      />
    </>
  );
}
